module.exports = __webpack_public_path__ + "img/egypt.dc39bfb8.svg";